import {
  Content,
  Holder,
  LeftHolder,
  MiddleHolder,
  RightHolder,
  LeftPic,
  LeftBottomHolder,
  TaylorPic,
  Text1,
  Text2,
  Divider,
  MiddleTopHolder,
  MiddleBottomHolder,
  CaptionHolder,
  Text3,
  Text4,
  RightTitle,
  RightImage,
  AboutLink,
  BackButton,
  BackIcon
} from "./Makers.style.js"
import TaylorIcon from "./taylor.svg"
import LeftTitleIcon from "./left_title.svg"
import { AboutPath } from "../../../routes"
import Arrows from "../../../components/Icons/navy_double_arrow_left.svg"

const pageVariants = {
  initial: {
    opacity: 0
  },
  in: {
    opacity: 1
  },
  out: {
    opacity: 0
  }
}

const pageTransition = {
  ease: "easeIn",
  duration: 0.7
}

function Makers() {
  return (
    <Holder
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      <Content>
        <LeftHolder>
          <LeftPic />
          <LeftBottomHolder>
            <TaylorPic src={TaylorIcon} />
            <Text3>
              Not all hosuebuilders are equal.
              <br />
              New Homes as they should be.
            </Text3>
            <Divider />
            <Text4>
              Taylor Wimpey Central London creates high-quality residential developments in sought
              after Zone 1 and 2 locations. Each development is bespoke to its area with handpicked
              designers and architects to match local needs and tastes. Success stems from
              responding to the market in good time and continually evolving to meet the needs of
              discerning buyers in the capital.
            </Text4>
          </LeftBottomHolder>
        </LeftHolder>
        <MiddleHolder>
          <MiddleTopHolder>
            <Text2>
              Taylor Wimpey Central London is part of one of the largest residential developers in
              the UK, the FTSE 100 listed Taylor Wimpey Plc.
            </Text2>
            <Text2>
              While every development in our portfolio is unique, all share the same ideals of
              expert design, high quality craftsmanship, practicality and investment security. And
              all come with our guarantee of excellent customer service.
            </Text2>
            <Text1>IT STARTS WITH OUR CUSTOMERS</Text1>
            <Text2>
              Our customers are at the heart of everything we do. We choose locations with great
              potential, in sought-after parts of central London. We design each development
              individually to make the best use of every feature inside and out, providing maximum
              space and light, and convenient access to local amenities and transport.
            </Text2>
            <Text2>
              We also invest in the surrounding area to ensure the best quality of life for everyone
              in and around our developments, now and for the future.
            </Text2>
            <Text2>
              We design, build and finish to the highest standards, providing a ten year NHBC
              guarantee. This is complemented by a warranty from Taylor Wimpey Central London for
              the first two years for maximum peace of mind on the quality of your property and
              security of investment.
            </Text2>
          </MiddleTopHolder>
          <MiddleBottomHolder>
            <CaptionHolder>
              When we're building your
              <br /> home,{" "}
              <span style={{ color: "#455754" }}>
                we never forget
                <br /> we're building your future.
                <br />
              </span>
              And we take this
              <br />
              responsibility very
              <br />
              seriously.
            </CaptionHolder>
          </MiddleBottomHolder>
        </MiddleHolder>
        <RightHolder>
          <RightTitle src={LeftTitleIcon} />
          <RightImage />
        </RightHolder>
      </Content>
      <AboutLink to={AboutPath}>
        <BackButton>
          <BackIcon src={Arrows} />
        </BackButton>
      </AboutLink>
    </Holder>
  )
}

export default Makers
